<template>
  <PageListTemplate title="Almanaque" :mod="mod" :cols="cols">
    <template #top>
      <FeaturedMagazineSection
        class="mb-10"
        v-bind="featuredMagazine"
        :loading="featuredMagazineLoading"
      />
    </template>

    <template #item="{ item }">
      <MagazineCard v-bind="item" />
    </template>

    <template #bottom>
      <BannerWidget
        class="mt-10"
        category="Retângulo"
        type="carousel"
        :items-to-show="{ xs: 1, sm: 2, md: 2, lg: 3, xl: 3 }"
      />
    </template>
  </PageListTemplate>
</template>

<script>
import PageListTemplate from "../components/templates/PageListTemplate.vue";
import BannerWidget from "../components/widgets/BannerWidget.vue";
import MagazineCard from "../components/cards/MagazineCard.vue";
import FeaturedMagazineSection from "../components/sections/FeaturedMagazineSection.vue";

export default {
  data: () => ({
    mod: "magazines",
    cols: { xs: 2, sm: 3, md: 4, lg: 5, xl: 5 },
    featuredMagazineLoading: true,
  }),
  computed: {
    featuredMagazine() {
      return this.$rest("featured-magazine").item;
    },
  },
  created() {
    this.$rest("featured-magazine")
      .get({
        save: (state, data) => (state.item = data),
      })
      .then(() => (this.featuredMagazineLoading = false));
  },
  components: {
    PageListTemplate,
    BannerWidget,
    MagazineCard,
    FeaturedMagazineSection,
  },
};
</script>
